import qs from 'qs';

/**
 * Trick to convert any object to Vue Router's ready QS transformation
 * @param {Object} Input object
 */
export default (obj) => {
    const url = new URL(location);
    const result = {};
    url.search = unescape(qs.stringify(obj));
    url.searchParams.forEach((item, key) => {
        result[key] = item;
    });
    return result;
};
